module.exports = __webpack_public_path__ + "static/media/phonemeIsolation-starter-intro.27d3b7b0.mp3";